import React, { useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import Navbar from '../Navbar';
import Header from '../Header';
import baseUrl from '../BaseUrl';
import '../active-users/active-users.css';
import './support-portal.css';

/**
 * Pauser Support (103) — /pauser-support
 *
 * A launch page for the Pauser Support console (Firebase Hosting, project pauser-574e1). The
 * console sends `X-Frame-Options: DENY`, so it cannot be embedded: this page says what the
 * console is for and links out to it. No API of our own — the token call only gates the page
 * like every other admin screen.
 */

export const SUPPORT_PORTAL_URL = 'https://pauser-574e1.web.app/';

const TOOLS = [
  { name: 'Answer support', text: 'Work the support chat queue. The person who has waited longest is at the top. You can also start a conversation for someone who reported a problem somewhere else.' },
  { name: 'User timeline', text: 'Everything one person did, in order, for one day. Useful when someone reports something you cannot reproduce.' },
  { name: 'Event search', text: 'Every occurrence of one event across a day or a range, whoever it happened to — or, given a device id, everything one device sent.' },
  { name: 'Installs', text: 'Every first open across a range, and whether each install went on to open the app, send our install event and sign in within 48 hours.' },
];

const SupportPortal = () => {
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${baseUrl}/admin/api/token`).catch((err) => {
      if (err.response) { navigate('/'); window.location.reload(); }
    });
  }, [navigate]);

  return (
    <div className="panelbox">
      <Navbar />
      <div className="right-panel">
        <Header name="Pauser" />
        <div className="content-page">
          <div className="au-head">
            <span className="au-breadcrumb">Support › <b>Pauser Support</b></span>
            <span className="au-route">/pauser-support</span>
            <span className="au-spacer" />
            <span className="au-back"><Link to="/dashboard">← Back</Link></span>
          </div>

          <div className="sp">
            <div className="au-card sp-hero">
              <h1 className="au-title">Pauser Support</h1>
              <p className="sp-lead">
                The support console is a separate app. Use it to answer members&apos; support chats and to look into
                what the app recorded for a person, a device or an install.
              </p>
              <div className="sp-cta">
                <a className="au-btn au-btn--primary sp-open" href={SUPPORT_PORTAL_URL} target="_blank" rel="noopener noreferrer">
                  Open Pauser Support ↗
                </a>
                <span className="sp-url">{SUPPORT_PORTAL_URL.replace(/^https:\/\//, '').replace(/\/$/, '')}</span>
              </div>
            </div>

            <h2 className="sp-section">What you can do there</h2>
            <div className="sp-tools">
              {TOOLS.map((t) => (
                <div className="au-card sp-tool" key={t.name}>
                  <h3 className="sp-tool-name">{t.name}</h3>
                  <p className="sp-tool-text">{t.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPortal;
